import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	goBack: {
		id: 'command-palette.modal.modal-content.header.go-back',
		defaultMessage: 'Go back',
		description:
			'Tooltip message that is displayed when user hovers over the back button on the command palette',
	},
});
